import React from 'react';
import { Link } from 'react-router-dom';
import about from '../img/about.jpg';

function ImageSection() {
    return (
        <div className="ImageSection">
            {/* <div className="img">
                <img src={about} alt=""/>
            </div> */}
            <div className="about-info">
                <h4>I am<span> Mainul Islam Fahim</span></h4>
                <p className="about-text">
                A passionate independent filmmaker and tech enthusiast. I believe in the power of storytelling and the limitless possibilities that technology offers in bringing those stories to life.
                </p>
                <h4>🎥 Filmmaker at Heart</h4>
                <p>From a young age, I've been captivated by the art of filmmaking. I love creating narratives that evoke emotions, challenge perspectives, and inspire audiences. Through my films, I strive to tell meaningful stories that have a lasting impact.</p>
                <h4>💻 Tech Enthusiast</h4>
                <p>In addition to my passion for filmmaking, I have a deep fascination with technology. I enjoy exploring the latest advancements in web development and leveraging them to build seamless digital experiences. With expertise in the Next.js, Node.js, Express, React, AWS, and MongoDB stack, I'm constantly pushing boundaries and seeking innovative solutions.</p>
                <h4>🎞️ Bridging Art and Technology</h4>
                <p>What sets me apart is my ability to merge my creative background with my technical skills. I thrive in bridging the gap between art and technology, bringing a unique perspective to my projects. Whether it's designing captivating user interfaces or optimizing backend processes, I'm dedicated to delivering high-quality results that exceed expectations.</p>
                <h4>🌟 Let's Collaborate</h4>
                <p>I'm always on the lookout for exciting opportunities to collaborate with fellow creatives, developers, and visionaries. If you have a project in mind, whether it's a film venture or a web development endeavor, I'd love to hear from you. Let's connect and explore how we can create something extraordinary together.</p>
                {/* <a className="btn" href="https://drive.google.com/uc?export=download&id=16R-LLRav7m_kYCV3xYi2DVwnOYsggRHV">Download Resume</a> */}
                <a className="btn" href="https://drive.google.com/file/d/1vMUydiuEGA-jTTs0NLtdCkSC08KldoBu/view?usp=sharing" download> Download Resume
                </a>

            </div>
        </div>
    )
}

export default ImageSection;
